import { atom, atomFamily } from "recoil";

import {
  IDropdownItem,
  IDropdownItemStations,
  IPassengerForStationDto,
  RydeUiUnitDropdownCacheKey,
} from "../../models";

export const dropdownAtomFamily = atomFamily<
  IDropdownItem[],
  RydeUiUnitDropdownCacheKey
>({
  key: "dropdownAtomFamily",
  default: [],
});

export const dropdownPassengersWithStationsAtom = atom<
  IPassengerForStationDto[] | undefined
>({
  key: "dropdownPassengersWithStationsAtom",
  default: undefined,
});

export const dropdownStationListAtom = atom<
  IDropdownItemStations[] | undefined
>({
  key: "dropdownStationListAtom",
  default: [],
});

export const dropdownBoundQuickAddOpenAtom = atomFamily<
  boolean,
  RydeUiUnitDropdownCacheKey
>({
  key: "dropdownBoundQuickAddOpenAtom",
  default: false,
});
